import React from 'react';

import { Tooltip, Typography } from '@mui/material';

import { getAttachmentScanState } from './attachmentScan';

import type { MalwareScanFields } from './attachmentScan';

interface AttachmentScanStatusProps {
  attachment: MalwareScanFields;
  showUnavailableReason?: boolean;
}

const AttachmentScanStatus = ({
  attachment,
  showUnavailableReason = false
}: AttachmentScanStatusProps): React.JSX.Element | null => {
  const scanState = getAttachmentScanState(attachment);
  if (scanState === 'available') return null;

  const isScanning = scanState === 'scanning';
  const label = isScanning ? 'Scanning' : 'File unavailable';
  const reason =
    showUnavailableReason && !isScanning
      ? (attachment.malware_scan_result ?? 'This file is unavailable.')
      : '';

  return (
    <Tooltip arrow placement="top" title={reason}>
      <Typography
        component="span"
        data-testid="attachment-scan-status"
        sx={{
          color: isScanning ? 'warning.dark' : 'error.main',
          cursor: reason ? 'help' : 'default',
          fontSize: '12px',
          fontWeight: 600
        }}
      >
        {label}
      </Typography>
    </Tooltip>
  );
};

export default AttachmentScanStatus;
